import { DictionariesService } from "@sa/rep-mdm";

export async function getCalendarOriginDictionary(dictionariesService: DictionariesService) {
  const calendarOriginDictionary = await dictionariesService.getDictionary({ id: "calendar-origin", parameters: {} });
  const calendarOrigin = await calendarOriginDictionary.getAll();

  return {
    calendarOrigin,
  };
}
